import React from 'react';
import {render} from 'react-dom';
import AppRouter from './Components/AppRouter/AppRouter';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-64352142-3');

const rootElement = document.getElementById('root');
render(<AppRouter location={{pathname: window.location.pathname}} />, rootElement);
